import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setLoader, setSnackbar } from 'redux/index';
import { getUserStateId } from 'redux/selectors';
import * as service from 'services';
import { PrimaryButton } from 'components';

export default function InviteSubmitButton({ infoState, handleValidate }) {
	const history = useHistory();
	const userId = useSelector(getUserStateId);
	const dispatch = useDispatch();
	const dispatchLoader = (val) => dispatch(setLoader(val));
	const dispatchSnackbar = (val, params) => dispatch(setSnackbar(val, params));

	const loadingFalse = () => {
		dispatchLoader(false);
		history.push(`/lifebooks`);
	};

	const loginAndInitialize = async (email, password) => {
		const loginReqBody = { email, password };
		const res = await service.loginEmailUser(loginReqBody);
		// setHeader only returns headers when the response carried a token;
		// a failed login or a 2FA challenge (202) has none
		const headers = !res?.error && (await service.setHeader(res));
		if (!headers) {
			// the account is already activated, so send them to sign in normally
			// instead of loading a user without a session
			dispatchSnackbar(
				{
					variant: 'success',
					message: 'Your account was created. Please sign in to continue.',
				},
				{ loggedIn: false }
			);
			history.replace('/login/');
			return;
		}
		// clear the invite token from the URL so apiV2 uses the new
		// session token instead of the now-consumed invite token
		history.replace(history.location.pathname);
		service.initializeUser('login', loadingFalse);
	};

	const submitStandaloneSwProfile = async () => {
		const { token, firstname, lastname, newPassword } = infoState;
		const acceptReqBody = {
			token,
			firstName: firstname.value,
			lastName: lastname.value,
			password: newPassword.value,
		};

		return await service
			.acceptStandaloneSwInvite(acceptReqBody)
			.then(async (res) => {
				await loginAndInitialize(res?.data?.user?.email, newPassword.value);
			})
			.catch(() => {
				dispatchSnackbar(
					{
						variant: 'error',
						message:
							'Profile could not be created. Please try again at a later time.',
					},
					{ loggedIn: false }
				);
			})
			.finally(() => {
				dispatchLoader(false);
			});
	};

	const submitProfile = async () => {
		const { firstname, lastname, newPassword, mobile, email } = infoState;
		const profileReqBody = {
			firstname: firstname.value,
			lastname: lastname.value,
			email: email.value,
			password: newPassword.value,
		};

		if (mobile.value) {
			profileReqBody.mobile = mobile.value;
		}
		return await service
			.activateUser(profileReqBody, userId)
			.then(async () => {
				await loginAndInitialize(email.value, newPassword.value);
			})
			.catch(() => {
				dispatchSnackbar(
					{
						variant: 'error',
						message:
							'Profile could not be created. Please try again at a later time.',
					},
					{ loggedIn: false }
				);
			})
			.finally(() => {
				dispatchLoader(false);
			});
	};

	const handleSubmit = async () => {
		dispatchLoader(true);
		if (await handleValidate()) {
			infoState.standaloneInvitation
				? submitStandaloneSwProfile()
				: submitProfile();
		} else {
			dispatchLoader(false);
		}
	};

	return <PrimaryButton onClick={handleSubmit}>Create Account</PrimaryButton>;
}
